import React, { ReactNode } from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { Attachment } from "@irvin-group/airtable-data-types";

interface Props {

  /** display an image from the attachment field directly from airtable */
  image?: Attachment

  /** use a thumbnail size instead of the originally uploaded image */
  thumbnail?: 'full' | 'small' | 'large'

  /** directly provide the airtable image url instead of providing a record */
  imageUrl?: string

  render: (url: string) => ReactNode
}

interface FileNode {
  publicURL: string
  relativePath: string
}

interface QueryResponse {
  files: {
    edges: ReadonlyArray<{ node: FileNode }>
  }
}

export default class AirtableImage extends React.Component<Props> {

  render()
  {
    return (
      <StaticQuery
        query={ graphql`
          query {
            files: allFile {
              edges {
                node {
                  publicURL
                  relativePath
                }
              }
            }
          }
        `}
        render={ data => this._render(data) } />
    );
  }

  _render(data: QueryResponse)
  {
    const files = data.files.edges.map(n => n.node);

    const { thumbnail, image, imageUrl } = this.props;

    if (!image && !imageUrl) {
      throw new Error('must provide either image or imageUrl');
    }

    if (thumbnail && imageUrl) {
      throw new Error('cannot provide a thumbnail when providing imageUrl directly')
    }

    if (image && !image.thumbnails) {
      throw new Error('missing thumbnails');
    }

    let airtableUrl: string;

    if (image && image.thumbnails) {
      console.log('thumbnail IS used')
      airtableUrl = thumbnail ? image.thumbnails[thumbnail].url : image.url;
    }
    else if (imageUrl) {
      console.log('thumbnail NOT used')
      airtableUrl = imageUrl;
    }
    else {
      throw new Error();
    }

    const match = airtableUrl.match(/(.*\/)?(.*)$/);

    if (!match || !match[2]) {
      throw new Error("problem with extracting filename from airtableUrl");
    }

    const filename = match[2];

    console.log(`files: ${files}`)
    const node = files.find(n => {``
      const filepath = n.relativePath.replace('attachments/', '');
      return filepath.includes(filename);
    });

    console.log(node)

    // if (!node) {
    //
    //   throw new Error(`file for ${airtableUrl} was not found in file nodes (${filename})`);
    // }
    if (!node) {
      console.error(`file for ${airtableUrl} was not found in file nodes (${filename})`);
      return (
          <div className="error-placeholder">
            <p>Error: Image not found</p>
            <p>{`File for ${airtableUrl} was not found in file nodes (${filename})`}</p>
          </div>
      );
    }

    return this.props.render(node.publicURL);
  }

}